import { Component, Vue, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';

import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import CommonRequests from '@/assets/ts/controller/CommonRequests';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import PopupController from '@/assets/ts/controller/PopupController';
import BiometriaDetalhes from '@/components/biometria/BiometriaDetalhes/BiometriaDetalhes.vue';


@Component({
  name: 'BiometriaFacial',
  components: {
    EditableTable,
    BiometriaDetalhes
  },
})
class BiometriaFacial extends Vue {
  // #region [ STORE ]
  private get periodoDemonstrativoAtual(): Periodo {
    return this.$store.getters.periodoDemonstrativoAtual;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (string) => void;
  // #endregion

  // #region [ DATA ]
  private readonly viewTitle = 'Biometria Facial';

  private quadroGeralVinculo: any[] = [];

  private loading = false;

  private vinculosQrCodes  = [] ;

  private gridSelected = [];

  private isOpenModalBiometria = false;

  private toolbarAdditionalActions = [];

  private rowSelected: any[] = [];

  private actions = [
    {
      name: 'Biometria',
      label: 'Biometria',
      icon: 'mdi-face-recognition',
      onClick: this.openModalBiometriaFacial,
      mode: 'view',
    },
  ];

  private columns: EditableTableColumn[] = [
    {
      text: 'Nr. Vínculo',
      value: 'NRVINCULOM',
      type: 'text',
    },
    {
      text: 'Nome',
      value: 'NMVINCULOM',
      type: 'text',
    },
    {
      text: 'Biometria Cadastrada?',
      value: 'BIOMETRIA_CADASTRADA',
      type: 'text',
    },
  ];

  private toolbarActions: ToolbarAction[] = [
    {
      name: 'reload',
      label: 'Atualizar',
      icon: 'mdi-refresh',
      onClick: this.reload,
    },
  ];
  // #endregion

  // #region [ COMPUTED ]
  private get filtersAreSelected(): boolean {
    const areSelected =
      !Util.isUndefinedOrNull(this.estruturaGerencialAtual) &&
      !Util.isUndefinedOrNull(this.periodoDemonstrativoAtual);

    return areSelected;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private async created() {
    this.changeCurrentView(this.viewTitle);
    (window as any).quadroGeralVinculo = this;
  }

  private mounted() {
    this.reload();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('estruturaGerencialAtual')
  private estruturaOnChange() {
    this.reload();
  }

  @Watch('periodoDemonstrativoAtual')
  private periodoOnChange() {
    this.reload();
  }
  // #endregion

  // #region [ METHODS ]
  private async reload() {
    if (!this.verifyFilters()) {
      return;
    }

    this.loading = true;
    this.quadroGeralVinculo = [];

    try {
      const quadroGeralVinculo = await CommonRequests.getVinculosDoGestor(false);

      this.quadroGeralVinculo = quadroGeralVinculo;
    } catch (err) {
      let message = '';

      if ((err as any).name === 'ExpectedError') {
        message = (err as any).message;
        message = message.replace('(HCMSERVICES) ', '');
      } else {
        message = 'Não foi possível carregar os vínculos!';
      }

      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    } finally {
      this.loading = false;
    }
  }

  private verifyFilters(): boolean {
    if (this.filtersAreSelected) {
      return true;
    }

    const message = 'Selecione uma unidade e um período!';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);

    return false;
  }

  private async openModalBiometriaFacial(row: any) {
    this.rowSelected = row;
    this.isOpenModalBiometria = true;
  }

  private novaBiometriaFacialAfterSave() {
    this.reload();
  }

}

export default BiometriaFacial;